import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        dark: false,
        themes: {
            light: {
                primary: '#1976D2',
                secondary: '#424242',
                accent: '#00BCD4',
                error: '#FF5252',
                info: '#2196F3',
                success: '#4CAF50',
                warning: '#FB8C00',
                background: '#FAFAFA',
            },
            dark: {
            }
        },
        options: {
            customProperties: true,
        },
    }
});
